import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from 'react-bootstrap/Pagination';
import Spinner from 'react-bootstrap/Spinner'; // Add this line
import styles from '../../CSS/TicketReaderList.module.css';

const NewTicketReaderList = () => {
    const navigate = useNavigate();
    const [devices, setDevices] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false); // Loading state
    const limit = 10;

    const fetchDevices = async (page) => {
        try {
            setLoading(true);
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/new-ticket-readers?page=${page}&limit=${limit}`
            );
            if (response.ok) {
                const data = await response.json();
                setDevices(data.devices);
                setTotalPages(data.totalPages);
                setCurrentPage(data.currentPage);
            } else {
                console.error("Failed to fetch new ticket readers");
            }
        } catch (error) {
            console.error("Error fetching devices:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDevices(currentPage);
    }, [currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleDelete = async (deviceId) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/new-ticket-readers/${deviceId}`, {
            method: 'DELETE'
        });
        if (response.ok) {
            navigate('/it/device');
        } else {
            alert('Failed to delete the device');
        }
    };

    return (
        <div className={styles.container}>
            <h2>New Ticket Reader Devices</h2>
            {loading ? (
                <div className="text-center my-5">
                    <Spinner animation="border" role="status" />
                    <div>Loading...</div>
                </div>
            ) : devices.length === 0 ? (
                <div className="text-center my-5">
                    <p>No devices found.</p>
                </div>
            ) : (
                <>
                    <table className={`table table-responsive ${styles.table}`}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Device ID</th>
                                <th>Ride Name</th>
                                <th>IP Address</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {devices.map((device, index) => (
                                <tr key={device._id}>
                                    <td>{(currentPage - 1) * limit + index + 1}</td>
                                    <td>{device.deviceId}</td>
                                    <td>{device.rideName || 'N/A'}</td>
                                    <td>{device.ip}</td>
                                    <td>
                                        <span className={`badge ${device.status === 'active' ? 'bg-success' : 'bg-danger'} ${styles.badge}`}>
                                            {device.status === 'active' ? 'Online' : 'Offline'}
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            onClick={() => navigate(`/it/new-ticket-reader/details/${device._id}`)}
                                            className={`btn btn-primary ${styles.btn}`}
                                        >
                                            Details
                                        </button>
                                        <button
                                            onClick={() => handleDelete(device._id)}
                                            className={`btn btn-danger ${styles.btn}`}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Pagination className="justify-content-center mt-4">
                        {Array.from({ length: totalPages }, (_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => handlePageChange(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </>
            )}
        </div>
    );
};

export default NewTicketReaderList;